import React from 'react';

import { Reference } from './StudyTypes';

import { StudyReference } from './StudyReference';

import * as styles from './ReferenceDocuments.module.css';

type StudyReferencesProps = {
  references: Reference[];
};

export function StudyReferences({ references }: StudyReferencesProps) {
  return (
    <div className={references.length > 1 ? styles.merged : ''}>
      {references.map((reference, i) => (
        <StudyReference
          key={i}
          {...reference}
          isMultiReference={references.length > 1}
        />
      ))}
    </div>
  );
}
